// extracted by mini-css-extract-plugin
module.exports = {"details":"_1sWu_JITRPvywVjWZP0hOW","details__info-panel":"_1g9MFVGS729QQ9_enK6s6n","details__spec-container":"_3JLStuOlpYK8Av_iWEwAIL"};